import api from './index';

let exports = {};

//登记合同信息
exports.registContract = function (data, callback) {// 登记合同
    api.post('/contract/regist/do')
    .data(data)
    .done(callback)
    .go();
};

//合同列表
exports.getContractList = function (data, callback) {// 获取合同列表
    api.post('/contract/list/get')
    .data(data)
    .done(callback)
    .go();
};

//查询合同信息
exports.getContractInfo = function (data, callback) {// 获取合同信息
    api.post('/contract/info/get')
    .data(data)
    .done(callback)
    .go();
};

//删除商品合同信息
exports.deleteContract = function (data, callback) {// 删除合同(暂时支持商品合同)
    api.post('/contract/delete/do')
    .data(data)
    .done(callback)
    .go();
};

//作废合同
exports.doInvalidContract = function (data, callback) {
    api.post('/contract/invalid/do')
    .data(data)
    .done(callback)
    .go();
};

//更新合同信息
exports.updateContract = function (data, callback) {// 更新合同信息
    api.post('/contract/update/do')
    .data(data)
    .done(callback)
    .go();
};

//更新合同所有信息
exports.updateContractInfo = function (data, callback) {
    api.post('/contract/info/update/do')
    .data(data)
    .done(callback)
    .go();
};
// 检查商品项是否再同期合同中是否已存在
exports.getCheckContractGoodsUkInfo = function (data, callback) {
    api.post('/contract/goods/info/check/do')
    .data(data)
    .done(callback)
    .go();
};

//确认合同信息
exports.auditAndConfirmContract = function (data, callback) {// 审核确认合同信息
    api.post('/contract/audit/and/confirm/do')
    .data(data)
    .done(callback)
    .go();
};

// 修订合同商品信息，不改变合同状态
exports.updateContractGoodsInfo = function (data, callback) {// 修订合同商品信息，不改变合同状态
    api.post('/contract/goodsInfo/update/do')
    .data(data)
    .done(callback)
    .go();
};
// 修订服务合同信息
exports.updateContractServcPurch = function (data, callback) {
    api.post('/contract/servc/purch/update/do')
    .data(data)
    .done(callback)
    .go();
};
// 合同付款阶段变更
exports.doSaveContractAcntPeriodFormAndPhasedPaySettingList = function (data, callback) {
    api.post('/contract/acntPeriodForm/and/phased/pay/setting/list/save/do')
    .data(data)
    .done(callback)
    .go();
};

//查询条款信息
exports.getContractTermList = function (data, callback) {// 获取合同条款列表
    api.post('/contract/term/list/get')
    .data(data)
    .done(callback)
    .go();
};

//验收合同
exports.getContractCheckResult = function (data, callback) {// 验收合同
    api.post('/contract/check/result/get')
    .data(data)
    .done(callback)
    .go();
};

// 根据合同id获取履约阶段
exports.getContractTrackPhaseListByContractId = function (data, callback) {// 根据合同id获取履约阶段
    api.post('/contract/track/phase/list/get/by/contractId')
    .data(data)
    .done(callback)
    .go();
};

//结束合同阶段
exports.stepToNextContractTrackPhase = function (data, callback) {// 结束当前阶段，自动进入下一阶段
    api.post('/contract/track/phase/stepToNext/do')
    .data(data)
    .done(callback)
    .go();
};
//合同阶段起算质保期
exports.doContractTrackPhaseStartWrntPeriod = function (data, callback) {
    api.post('/contract/track/phase/start/wrntPeriod/do')
    .data(data)
    .done(callback)
    .go();
};

//履约完成申请审核
exports.auditContractFulfillFinished = function (data, callback) {// 履约完成审核
    api.post('/contract/fulfill/finished/audit/do')
    .data(data)
    .done(callback)
    .go();
};

// 继续履约操作
exports.doUpdateContractKeepFulfilled = function (data, callback) {// 继续履约操作
    api.post('/contract/keep/fulfilled/update/do')
    .data(data)
    .done(callback)
    .go();
};

//获取合同监控数据
exports.getContractMonitorDataList = function (data, callback) {// 获取合同监控数据列表
    api.post('/contract/monitor/data/list/get')
    .data(data)
    .done(callback)
    .go();
};

//带分页的合同操作记录列表
exports.getContractRecordList = function (data, callback) {// 获取合同操作记录列表
    api.post('/contract/record/list/get')
    .data(data)
    .done(callback)
    .go();
};
//带分页的合同操作记录列表
exports.updateContractGoodsAssetInfoById = function (data, callback) {// 获取合同操作记录列表
    api.post('/contract/update/contact/goods/assetInfo/by/id')
    .data(data)
    .done(callback)
    .go();
};

//零售门店可用合同服务列表
exports.getContractAvlServcListOfRetailerShop = function (data, callback) {// 获取零售门店可用合同服务列表
    api.post('/contract/avl/servc/list/of/retailer/shop/get')
    .data(data)
    .done(callback)
    .go();
};

//根据唯一键获取零售门店可用合同服务
exports.getContractAvlServcOfRetailerShopByUk = function (data, callback) {// 根据唯一键获取零售门店可用合同服务
    api.post('/contract/avl/servc/of/retailer/shop/get/by/uk')
    .data(data)
    .done(callback)
    .go();
};

//根据合同查询对应服务中的goodsCatIds信息
exports.getContractServcGoodsCatIds = function (data, callback) {// 根据合同查询对应服务中的goodsCatIds信息
    api.get('/contract/servc/goods/cat/ids/get/by/contractId')
    .params(data)
    .done(callback)
    .go();
};

//申请审核合同信息
exports.applyContract = function (data, callback) {// 申请合同
    api.post('/contract/apply/do')
    .data(data)
    .done(callback)
    .go();
};

// 获取合同日志
exports.getContractLog = function (params, callback) {
    api.get('/contract/log/get')
    .params(params)
    .done(callback)
    .go();
};

// 获取合同日志列表
exports.getContractLogListByContractNo = function (params, callback) {
    api.get('/contract/log/list/get/by/contractNo')
    .params(params)
    .done(callback)
    .go();
};

//合同发送站点信
exports.doContractSendMsg = function (data, callback) {
    api.post('/contract/send/msg/do')
    .data(data)
    .done(callback)
    .go();
};

// 老合同验证
exports.checkLegacyContract = function (callback) {
    api.post('/contract/legacy/contract/check')
    .done(callback)
    .go();
};

// 异常终止合同操作
exports.doAbortContract = function (data, callback) {
    api.post('/contract/abort/do')
    .data(data)
    .done(callback)
    .go();
};

// 获取合同商品分页列表
exports.getContractGoodsPagedList = function (data, callback) {
    api.post('/contract/goods/paged/list/get')
    .data(data)
    .done(callback)
    .go();
};

// 获取合同适用机构
exports.getContractAppliedShopList = function (data, callback) {
    api.post('/contract/applied/shop/list/get')
    .data(data)
    .done(callback)
    .go();
};

// 获取合同适用机构的全部合同的ids
exports.getContractAppliedShopContractIdList = function (data, callback) {
    api.post('/contract/applied/shop/contractId/list/get')
    .data(data)
    .done(callback)
    .go();
};

// 获取合同适用机构ids
exports.getContractAppliedShopIds = function (data, callback) {
    api.post('/contract/applied/shopIds/get')
    .data(data)
    .done(callback)
    .go();
};

// 设置合同适用机构
exports.saveContractAppliedShopBatch = function (data, callback) {
    api.post('/contract/applied/shop/save/do')
    .data(data)
    .done(callback)
    .go();
};
// 设置合同适用机构
exports.deleteContractDevicceByUk = function (data, callback) {
    api.post('/contract/device/delete/do/by/Uk')
    .data(data)
    .done(callback)
    .go();
};
// 设置合同适用机构
exports.getContractDeviceDevcSvcSubIds = function (data, callback) {
    api.post('/contract/device/devcSvcSubId/list/get/by/contractId/and/retailerShopId')
    .data(data)
    .done(callback)
    .go();
};
// 移除合同适用机构
exports.deleteContractAppliedShopById = function (data, callback) {
    api.post('/contract/applied/shop/delete/do/by/id')
    .data(data)
    .done(callback)
    .go();
};
// 根据设备查找合同信息
exports.getContractByDeviceNo = function (data, callback) {
    api.post('/contract/get/by/devcSubNoId')
    .data(data)
    .done(callback)
    .go();
};
// ================ 区域价格 =================
// 根据合同商品id获取区域价格列表
exports.getContractGoodsAreaPriceListByContractGoodsItemId = function (params, callback) {
    api.get('/contract/goods/area/price/list/get/by/contractGoodsItemId')
    .params(params)
    .done(callback)
    .go();
};

// =============== 合同导入 ========================
// 合同导入模版校验
exports.validateContractImpModel = function (data, callback) {
    api.post('/contract/imp/model/validate')
    .data(data)
    .done(callback)
    .go();
};

// 合同导入
exports.doContractImpModelImport = function (data, callback) {
    api.post('/contract/imp/model/import/do')
    .data(data)
    .done(callback)
    .go();
};

// 合同信息导出
exports.contractImpModelForExport = function (data, callback) {
    api.post('/contract/imp/model/for/export/url')
    .data(data)
    .done(callback)
    .go();
};

// 合同费用项目
exports.getContractFeeItemList = function (data, callback) {
    api.post('/contract/feeItem/list/get')
    .data(data)
    .done(callback)
    .go();
};

// 检查合同适用机构导入信息
exports.checkContractAppliedShopInfo = function (data, callback) {
    api.post('/contract/check/applied/shop/Info/for/impl')
    .data(data)
    .done(callback)
    .go();
};

exports.getContractServc = function (data, callback) {
    api.post('/contract/servc/list/get')
    .data(data)
    .done(callback)
    .go();
};

// 查询合同服务特定价格预览
exports.getContractServcOrgPriceRecList = function (data, callback) {
    api.post('/contract/servc/org/price/rec/list/get')
    .data(data)
    .done(callback)
    .go();
};

// 查询合同服务2特定价格预览
exports.getContractServc2OrgPriceRecList = function (data, callback) {
    api.post('/contract/servc2/org/price/rec/list/get')
    .data(data)
    .done(callback)
    .go();
};

export default exports;



//////////////////
// WEBPACK FOOTER
// ./src/api/contract.js
// module id = 28
// module chunks = 0